import React from 'react';
import styles from './styles.scss';

function PMForm ({
  linkedInURL,
  employer,
  position,
  availability,
  designTypes,
  teamSize,
  characteristic,
  processDescription,
  onChangeField
}) {
  return (
    <div className="container-fluid main-container">
      <div className="col-md-10 col-md-offset-1 col-sm-12">
        <div className="row">
          <div className="col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 col-xs-12">
            <div className="form-group">
              <label className="bold" htmlFor="websiteURL">YOUR LINKEDIN URL</label>
              <input
                type="text"
                className="form-control input-lg"
                id="linkedInURL"
                placeholder="www.linkedin.com/YOURNAME"
                name="linkedInURL"
                value={linkedInURL}
                onChange={onChangeField}
              />
            </div>
            <div className="form-group">
              <label className="bold" htmlFor="employer">WHO IS YOUR CURRENT OR LAST EMPLOYER?</label>
              <input
                type="text"
                className="form-control input-lg"
                id="employer"
                placeholder="Enter employer info"
                name="employer"
                value={employer}
                onChange={onChangeField}
              />
            </div>
            <div className="form-group">
              <label className="bold" htmlFor="dribbbleURL">WHAT WAS YOUR POSITION?</label>
              <input
                type="text"
                className="form-control input-lg"
                id="position"
                placeholder="Enter your position"
                name="position"
                value={position}
                onChange={onChangeField}
              />
            </div>
            <div className="form-group">
              <div className="form-label bold">WEEKLY AVAILABILITY</div>
              <div className="row">
                <div className="col-sm-10">
                  <div className="row">
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${availability === 'Part-Time' ? 'inverse' : ''}`}>
                        Part-Time
                        <input
                          type="radio"
                          id="availability"
                          name="availability"
                          value="Part-Time"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${availability === 'Full-Time' ? 'inverse' : ''}`}>
                        Full-Time
                        <input
                          type="radio"
                          id="availability"
                          name="availability"
                          value="Full-Time"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <div className="form-label bold">WHAT SIZE TEAM HAVE YOU MANAGED?</div>
              <div className="row">
                <div className="col-sm-10">
                  <div className={`row mb10 ${styles.radioSelection}`}>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${teamSize === '1-3' ? 'inverse' : ''}`}>
                        1-3
                        <input
                          type="radio"
                          id="teamSize"
                          name="teamSize"
                          value="1-3"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${teamSize === '3-10' ? 'inverse' : ''}`}>
                        3-10
                        <input
                          type="radio"
                          id="teamSize"
                          name="teamSize"
                          value="3-10"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                  </div>
                  <div className={`row ${styles.radioSelection}`}>
                    <div className="col-xs-6">
                      <label className={`btn btn-block btn-dc-primary ${teamSize === '10+' ? 'inverse' : ''}`}>
                        10+
                        <input
                          type="radio"
                          id="teamSize"
                          name="teamSize"
                          value="10+"
                          onChange={onChangeField}
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group">
              <label className="bold" htmlFor="processDescription">
                DESCRIBE YOUR PROCESS IN TAKING AN APP FROM IDEA TO COMPLETION:
              </label>
              <textarea
                className="form-control input-lg"
                rows="5"
                id="processDescription"
                placeholder="Enter your process"
                name="processDescription"
                value={processDescription}
                onChange={onChangeField}
              />
            </div>
            <div className="form-group">
              <label className="bold" htmlFor="dribbbleURL">AS A TEAM LEADER, WHAT IS YOUR GREATEST CHARACTERISTIC?</label>
              <input
                type="text"
                className="form-control input-lg"
                id="characteristic"
                placeholder="Enter your greatest characteristic"
                name="characteristic"
                value={characteristic}
                onChange={onChangeField}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PMForm;



// WEBPACK FOOTER //
// ./src/components/PMForm/index.js